<template>
    <section>
        <div class="container">
            <div class="row">
                <div class="col-xs-12">
                    <div class="row row-space-between row-space-top">
                        <div class="col-size-auto">
                            <h2 class="subtitle">Leveringsterminer</h2>
                            <span v-html="text"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        name: 'model-details-delivery-deadlines',
        props: {
            text: {
                type: String,
                default: undefined
            }
        },
        data() {
            return {

            }
        }
    }
</script>